var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showWarning)?_c('div',{staticClass:"cultural-sensitivity-warning"},[_c('div',{staticClass:"alert"},[_c('div',{staticClass:"icon"},[_c('font-awesome-icon',{attrs:{"icon":{ prefix: 'fal', iconName: 'exclamation-triangle' },"size":"2x"}})],1),_c('div',{staticClass:"text-and-actions"},[_vm._t("text-and-actions")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }